// The caller must await the answer before starting an operation.
function createConfirmationService (state = { active: null }) {
  let resolveAnswer = null

  function answer (accepted) {
    if (!resolveAnswer) {
      return
    }
    const resolve = resolveAnswer
    resolveAnswer = null
    state.active = null
    resolve(accepted === null ? null : accepted === true)
  }

  return {
    state,
    confirm (message, options = {}) {
      // Ignore a second click while a question is open instead of authorizing
      // multiple operations with the same answer or stacking dialogs.
      if (resolveAnswer) {
        return Promise.resolve(null)
      }
      return new Promise(resolve => {
        resolveAnswer = resolve
        state.active = {
          title: 'Confirmar operação',
          confirmText: 'Confirmar',
          cancelText: 'Cancelar',
          color: 'primary',
          icon: 'mdi-help-circle-outline',
          ...options,
          message,
        }
      })
    },
    answer,
    // null means abandonment (navigation/destruction), false is an explicit No.
    cancel () {
      answer(null)
    },
  }
}

module.exports = { createConfirmationService }
